import { getAPIConfig } from '@tcp/core/src/utils';
import { getLocalStorage, setLocalStorage } from './localStorageManagement';
import BUILD_NUMBER_KEY from '../constants/build.constants';

export const getCurrentBuildNumber = () => getAPIConfig().BUILD_NUMBER;

export const storeBuildNumber = () => {
  const buildNumber = getCurrentBuildNumber();
  if (buildNumber) {
    setLocalStorage({ key: BUILD_NUMBER_KEY, value: getCurrentBuildNumber() });
  }
};

export const isNewBuildDetected = () => {
  const previousBuildVersion = getLocalStorage(BUILD_NUMBER_KEY) || '';
  return previousBuildVersion !== getCurrentBuildNumber();
};
